import { render } from "./sf.vue?vue&type=template&id=be2788de&scoped=true"
import script from "./sf.vue?vue&type=script&lang=js"
export * from "./sf.vue?vue&type=script&lang=js"

import "./sf.vue?vue&type=style&index=0&id=be2788de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be2788de"

export default script